// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const config = Promise.resolve({
	stripeKey: 'pk_test_otPk3x4Vhm2MRJ9Lm1Syf6m8',
	usStripeKey: 'pk_test_icn4yOH6qHBPU3PO86CEWcy4',
	authClientId: 'IaNABQKr1qlKlWAehEUo2MCBWsAaGauk',
	authClientURL: 'https://amazingco.au.auth0.com/oauth/token',
	authClientSecret: '0vs_Qu1W0TBBqSXW9J5-86dEY_Yrr_ojRJGzAfG-ccum2Ifo1D2g_02RY-xHeVVV',
	authClientAudiences: 'https://giftcard-api.amazingco.me',
	authClientGrantType: 'client_credentials',
	aexHQURL: 'http://aex-hq-dev.amazingco.me',
	uhqURL: 'http://dev-uhq.amazingco.me',
	websiteUrl:'https://singularity-dev.amazingco.me',
	acHubUrl: 'https://hub.dev.in.amazingco.me'
    // acHubUrl: 'http://localhost:3000'
});

export const environment = {
	production: false,
	googleApiKey: 'AIzaSyD-PxCkJDcTe7twP8VjXT8sxf93iwYHhbQ',
	getConfig(key: string): Promise<string> {
		return config.then(x => x[key]);
	},
};

export function initializeConfig() {
	return function () {};
}
